import { handleError } from '../error-reporting';
import type { AppValues } from '@tectonics/app-values';
import type { UserInputName } from '@tectonics/prs/user-input';
import type { UserInputValidationError } from '@tectonics/prs/validation';

interface RegisterInputErrorsArgs {
  readonly userInputValidationErrors: ImmutableArray<[UserInputName, UserInputValidationError]>;
  readonly hasValidatedLAF: boolean;
  readonly hasLAFValidationErrors: boolean;
}

type RegisterInputErrors = (args: RegisterInputErrorsArgs) => void;

export function useInputErrors(appValues: AppValues): RegisterInputErrors {
  const registerInputErrors = ({
    userInputValidationErrors,
    hasValidatedLAF,
    hasLAFValidationErrors,
  }: RegisterInputErrorsArgs) => {
    if (appValues['abwAlertsBlock']) {
      return ;
    }

    if (userInputValidationErrors.length > 0 && (hasValidatedLAF && !hasLAFValidationErrors)) {
      const prettyErrorList = prettifyUserInputValidationErrors(userInputValidationErrors);
      handleError(new Error(`ABW: Validation errors encountered, but no Input Field Errors detected:\n\n${prettyErrorList}\n`));
    }
  };

  return registerInputErrors;
}

function prettifyUserInputValidationErrors(
  userInputValidationErrors: ImmutableArray<[UserInputName, UserInputValidationError]>,
): string {
  return userInputValidationErrors
    .map(([userInputName, userInputValidationError]) => `- ${userInputName}: ${JSON.stringify(userInputValidationError)}`)
    .join('\n');
}
